import * as React from "react";

interface UndoIconProps {
  id: string;
}

export const UndoIcon: React.SFC<UndoIconProps> = ({ id }) => {
  return (
    <svg
      width="21px"
      height="9px"
      viewBox="0 0 21 9"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <path
          d="M10.5,1 C7.85,1 5.45,1.99 3.6,3.6 L0,0 L0,9 L9,9 L5.38,5.38 C6.77,4.22 8.54,3.5 10.5,3.5 C14.04,3.5 17.05,5.81 18.1,9 L20.47,8.22 C19.08,4.03 15.15,1 10.5,1 Z"
          id={`path-undo-${id}`}
        />
      </defs>
      <g
        id={`Mapping-+-Rules-v2-${id}`}
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id={`Mapping-Mode---Undo-Hover-${id}`}
          transform="translate(-644.000000, -485.000000)"
        >
          <g
            id={`Icons/Undo-${id}`}
            transform="translate(642.000000, 478.000000)"
          >
            <g>
              <polygon id={`Path-${id}`} points="0 0 24 0 24 24 0 24" />
              <g
                id={`icon-color-${id}`}
                transform="translate(2.000000, 7.000000)"
              >
                <mask id={`mask-undo-${id}`} fill="white">
                  <use xlinkHref={`#path-undo-${id}`} />
                </mask>
                <use
                  id={`Mask-${id}`}
                  fill="#747474"
                  fillRule="nonzero"
                  xlinkHref={`path-undo-${id}`}
                />
                <g
                  id="Color-/-Darkest-Gray"
                  mask={`url(#mask-undo-${id})`}
                  fill="#747474"
                >
                  <g
                    transform="translate(-2.000000, -7.000000)"
                    id="Rectangle-2"
                  >
                    <rect x="0" y="0" width="24" height="24" />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};



// WEBPACK FOOTER //
// ./src/spread/chartOfAccounts/UndoIcon.tsx